import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const location = useLocation();
  // Chrome 150+ returns a Promise from scrollTo. Returning that from useEffect makes
  // React treat it as a cleanup function and crash on the next navigation
  // ("TypeError: n is not a function"). Always use a block body so the effect
  // returns undefined (or an explicit cleanup function).
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return children;
};

export default ScrollToTop;
